class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);


document.addEventListener('DOMContentLoaded', () => {
  const trigger = document.querySelector('.js-wrapper-search');
  const compactTrigger = document.querySelector('.js-compact-search');
  const layer = document.querySelector('.search__wrapper');
  const closeButton = document.querySelector('.js-wrapper-close');
  const input = document.getElementById('Search-In-Modal');
  if (!trigger || !layer || !closeButton || !input) return;
  document.body.appendChild(layer);
  let previousFocus;
  let previousScroll = 0;
  let bodyStyle;
  const viewport = () => {
    layer.style.setProperty('--ux-search-height', `${window.visualViewport?.height || window.innerHeight}px`);
    layer.style.setProperty('--ux-search-top', `${window.visualViewport?.offsetTop || 0}px`);
  };
  const close = () => {
    if (!layer.classList.contains('--active')) return;
    input.blur();
    layer.classList.remove('--active');
    if (bodyStyle) Object.assign(document.body.style, bodyStyle);
    document.body.classList.remove('overflow-hidden');
    const predictive = layer.querySelector('predictive-search');
    if (predictive && typeof predictive.close === 'function') predictive.close(false);
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
    const restoreFocus = previousFocus?.getClientRects().length ? previousFocus : compactTrigger?.getClientRects().length ? compactTrigger : trigger.querySelector('button');
    restoreFocus?.focus({ preventScroll: true });
    window.scrollTo({ top: previousScroll, behavior: 'instant' });
  };
  const open = (event) => {
    if (layer.classList.contains('--active')) return;
    previousFocus = event?.currentTarget === compactTrigger ? compactTrigger : trigger.querySelector('button') || document.activeElement;
    previousScroll = window.scrollY;
    bodyStyle = { position: document.body.style.position, top: document.body.style.top, width: document.body.style.width };
    Object.assign(document.body.style, { position: 'fixed', top: `-${previousScroll}px`, width: '100%' });
    viewport();
    layer.classList.add('--active');
    document.body.classList.add('overflow-hidden');
    if (typeof trapFocus === 'function') trapFocus(layer, input);
    else input.focus();
  };
  trigger.addEventListener('click', open);
  compactTrigger?.addEventListener('click', open);
  trigger.addEventListener('keydown', event => {
    if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); open(); }
  });
  closeButton.addEventListener('click', close);
  layer.addEventListener('click', event => { if (event.target === layer) close(); });
  window.visualViewport?.addEventListener('resize', viewport);
  window.visualViewport?.addEventListener('scroll', viewport);
  layer.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); close(); }
  });
});
